import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { label } from "@/lib/format";

export function usePoDuplicates(po, customerId, excludeId) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!customerId || !String(po || "").trim()) { setRows([]); return undefined; }
    const t = setTimeout(() => api.get("/orders/po-check", { params: { customer_id: customerId, po_no: po, exclude_id: excludeId || "" } }).then((r) => setRows(r.data)).catch(() => setRows([])), 350);
    return () => clearTimeout(t);
  }, [po, customerId, excludeId]);
  return rows;
}

export function PoDuplicateNote({ rows, testid = "po-duplicate-note" }) {
  if (!rows.length) return null;
  return (
    <div className="flex items-start gap-2 rounded border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900" data-testid={testid}>
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
      <div><b>This PO number is already used on {rows.length} other LM(s) for this customer.</b> That is allowed (one PO can be split across LMs) — check it is not a duplicate entry:
        <div className="mt-1 flex flex-wrap gap-x-3">{rows.map((r) => <Link key={r.id} to={`/orders/${r.id}`} className="font-mono font-semibold text-sky-800 hover:underline">{r.order_no} · {label(r.status)}</Link>)}</div>
      </div>
    </div>
  );
}
